export default __webpack_public_path__ + "static/media/powered-by-iov-gray.e25db553.svg";